<template>
  <header
    class="mobile"
    :class="{ 'grid-container': isMcom, 'header-with-active-search': isSearchModalActive && killswitches.masterMewWhitespaceRemovalEnabled }"
  >
    <slot name="top"></slot>

    <div :class="containerClasses">
      <MobileMainRailCondensed />
      <Search v-if="isSearchEnabled" />
      <slot name="bottom"></slot>
    </div>

    <MobileMenu />
  </header>
</template>

<script setup>
import { computed } from 'vue';
import Search from '~/components/search/Search.common';
import MobileMenu from './MobileMenu.common';
import MobileMainRailCondensed from './MobileMainRailCondensed';
import useKillswitches from '~/composables/useKillswitches';
import { GET_ATTRS } from '#shared/types/getters';

const navHeader = useNavHeader();
const killswitches = useKillswitches();
const { isMcom } = useEnvProps();
const isSearchEnabled = computed(() => {
  return !isMcom || !!navHeader[GET_ATTRS].isProminentSearchBar;
});
const isSearchModalActive = computed(() => navHeader.isSearchModalActive);
const containerClasses = computed(() => {
  if (!isMcom) {
    return ['grid-container', 'padding-bottom-xs'];
  }
  if (navHeader[GET_ATTRS].isProminentSearchBar) {
    return ['padding-bottom-xs'];
  }
  return ['pb-8'];
});
</script>

<style lang="scss">
.header-with-active-search {
  position: relative;

  &:after {
    content: '';
    display: block;
    position: absolute;
    background: $white;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
</style>
